import {
    AbstractDataState,
    useGetSimpleApiData,
    useGetSimpleApiDataWithTransformer,
} from '@cp-shared-19/frontend-integration';
import { fetchCustomerType } from './CustomerTypeSlice';
import { CustomerTypeSelector, setDefaultCustomerType } from './CustomerTypeSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-19/common-utilities';
import { CustomerType } from 'cpes-common';

export function useCustomerType(
    isAuthenticated: boolean,
): AbstractDataState<CustomerType, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(
        fetchCustomerType,
        CustomerTypeSelector,
        undefined,
        undefined,
        undefined,
        isAuthenticated,
    );
}

export function useCustomerTypeWithDefaultValue(): AbstractDataState<CustomerType, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiDataWithTransformer(fetchCustomerType, CustomerTypeSelector, setDefaultCustomerType);
}
